import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issues: {
		id: 'software-releases-version-detail-issue-list.issues',
		defaultMessage: 'Issues',
		description:
			'Subheading for a section of the page which shows the issues that are within the version',
	},
	addIssueIconLabel: {
		id: 'software-releases-version-detail-issue-list.add-issue-icon-label',
		defaultMessage: 'Add issues',
		description: 'Label for the icon button to add issues',
	},
});
